import { PollOption } from "@infrastructure/Services/PostService.types";
import { PollCountBox } from "./PostActionButtons.styles";
import { CircleCheckSolidIcon } from "@icons/CircleCheckSolidIcon";
import { getLocalStoragePolls } from "@infrastructure/Persistence/LocalUserStorage";
import { useMemo } from "react";
import { CircleCheckLightIcon } from "@icons/CircleCheckLightIcon";

export function PostPollStats({
    postPollOptions,
    postId,
}: {
    postId: number | string;
    postPollOptions: PollOption[];
}) {
    const currentTotalCount = postPollOptions.reduce(
        (total, postOption) => total + postOption.responsesCount,
        0,
    );

    const userPolls = getLocalStoragePolls();
    const userVoted = useMemo(
        () => userPolls.some((poll) => poll.postId === postId),
        [postId, userPolls],
    );

    if (!currentTotalCount) {
        return null;
    }

    return (
        <PollCountBox>
            {userVoted ? (
                <CircleCheckSolidIcon
                    color="var(--community-color-primary-text)"
                    width="16px"
                    height="16px"
                />
            ) : (
                <CircleCheckLightIcon
                    color="var(--community-color-primary-text)"
                    width="16px"
                    height="16px"
                />
            )}
            {currentTotalCount.toLocaleString("de-DE")}
        </PollCountBox>
    );
}
